package empiresmp.feature.votes.ui

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px
import ru.astrainteractive.kobwebx.core.resource.Resources
import ru.astrainteractive.kobwebx.core.theme.composable.LocalSitePalette
import ru.astrainteractive.kobwebx.core.theme.util.ThemeExt.typography

@Composable
fun ButtonWithIconComposable(
    icon: String,
    text: String,
    onClick: () -> Unit,
    hasAward: Boolean,
    isVoted: Boolean,
    modifier: Modifier = Modifier.Companion
) {
    val theme = LocalSitePalette.current

    Box(
        modifier = modifier,
        contentAlignment = Alignment.TopStart
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(theme.dimens.XS),
            modifier = Modifier.Companion
                .margin(16.px)
                .backgroundColor(theme.colors.colorSecondary)
                .borderRadius(theme.dimens.L)
                .textAlign(TextAlign.Companion.Center)
                .padding(topBottom = theme.dimens.S, leftRight = theme.dimens.L)
                .fontWeight(FontWeight.Companion.Bold)
                .onClick(listener = { onClick.invoke() })
        ) {
            Image(
                src = icon,
                modifier = Modifier.Companion.size(32.px)
            )
            SpanText(
                text = text,
                modifier = theme.typography.h3.toModifier()
                    .color(theme.colors.colorOnSecondary)
            )
        }

        if (hasAward) {
            IconBackgroundComposable(
                icon = Resources.icPrize.path,
                background = theme.colors.colorSecondaryVariant,
                modifier = Modifier.Companion.align(Alignment.TopStart)
            )
        }
        if (isVoted) {
            IconBackgroundComposable(
                icon = Resources.icCheck.path,
                background = theme.colors.colorSuccess,
                modifier = Modifier.Companion.align(Alignment.TopEnd)
            )
        }
    }
}
